import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cdd642a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Unsubscribe Agent ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Remove ")

import { computed, ref, VNodeRef } from 'vue';
import { License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import AgentsAddBuildGroup from '@/views/agents/components/action-menu/agents-build-group.vue';
import AgentsServerSubscription from '@/views/agents/components/action-menu/agents-server-subscription.vue';
import { useAgentActionMenuUtils } from '@/components/agents-table/AgentTable/components/AgentActionMenu/OS/AgentActionMenu.helpers';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import manageBuildGroupsDialog from '@/views/agents/components/buildGroups/manageBuildGroupsDialog.vue';
import { useIncrediDialog } from 'incredi-ui';
import AgentActionSetDescription from '@/components/agents-table/AgentActionSetDescription.vue';
import { useNotifyPresets } from '../../../../services/notifyPresets';
import { useAgentActionsMenu } from '../../../../AgentActionsMenu.helpers';
import { SelectedAgent } from '../../../../AgentActionMenu.types';
import AgentCloudBulkActionMenu from '../../../../AgentCloudBulkActionMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentActionMenu.linux',
  props: {
    beforeHide: null,
    agent: null,
    contextMenu: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  beforeHide?: () => void;
  agent: SelectedAgent;
  contextMenu?: boolean;
}

const IcmMenuRef = ref<VNodeRef>();
const agentsActions = useAgentActionsMenu(OsType.Linux, IcmMenuRef);
const { notifyPresets } = useNotifyPresets();
const agentsActionsMenu = useAgentActionMenuUtils();
const dialog = useIncrediDialog();



const openBuildGroupsDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide(); // close agent actions menus
  dialog?.open('manageBuildGroupsDialog', manageBuildGroupsDialog, {});
};

const isAgentUsedAllCoresForSubscription = computed(() => props.agent?.license?.registeredCores === props.agent?.performance?.cpuPhysical);
const isAgentSubscribed = computed(() => props.agent?.license?.status);
const isAgentOffline = computed(() => props.agent?.metadata?.isOffline);
const isCloudAgent = computed(() => props.agent?.metadata?.isCloud);
const isDefaultMenu = computed(() => !isCloudAgent.value && !isAgentOffline.value);
const menuOptions = computed(() => ({
  attrs: {
    rootClass: 'incredi-q-menu incredi-q-menu-agents',
    activeClass: 'incredi-q-item-active',
    'context-menu': props.contextMenu,
    ...(agentsActionsMenu.menuOpeningDirection.value as { self: string; anchor: string }),
  },
  listeners: {
    'before-hide': props.beforeHide,
    'before-show': agentsActionsMenu.beforeShow,
  },
}));

return (_ctx: any,_cache: any) => {
  const _component_IcmMenuSubmenu = _resolveComponent("IcmMenuSubmenu")!
  const _component_IcmMenuItem = _resolveComponent("IcmMenuItem")!
  const _component_IcmMenu = _resolveComponent("IcmMenu")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(_component_IcmMenu, _mergeProps({
    ref_key: "IcmMenuRef",
    ref: IcmMenuRef,
    "hover-mode": ""
  }, _unref(menuOptions).attrs, _toHandlers(_unref(menuOptions).listeners)), {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.agent.name), 1)
    ]),
    default: _withCtx(({ bind }) => [
      (_unref(isDefaultMenu))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 0,
            disabled: _unref(isAgentUsedAllCoresForSubscription)
          }, bind, {
            portal: "",
            label: "Subscribe Agent",
            "data-testid": "subscribe-agent"
          }), {
            default: _withCtx(() => [
              _createVNode(AgentsServerSubscription, {
                disable: _unref(isAgentUsedAllCoresForSubscription),
                agents: [__props.agent],
                onChange: _unref(agentsActions).setAgentsLicense
              }, null, 8, ["disable", "agents", "onChange"])
            ]),
            _: 2
          }, 1040, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(isDefaultMenu))
        ? (_openBlock(), _createBlock(_component_IcmMenuSubmenu, _mergeProps({
            key: 1,
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.buildGroup')
          }, bind, { "data-testid": "add-to-build-group-action" }), {
            default: _withCtx(() => [
              _createVNode(AgentsAddBuildGroup, {
                "data-testid": "add-to-build-group-action-dialog",
                agents: [__props.agent],
                onOpenDialog: _cache[0] || (_cache[0] = () => openBuildGroupsDialog()),
                onChange: _cache[1] || (_cache[1] = 
            value => {
              value.status ? _unref(agentsActions).setBuildGroup([__props.agent], value.buildGroup) : _unref(notifyPresets).agentSingeActionFail();
            }
          )
              }, null, 8, ["agents"])
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_IcmMenuSubmenu, _mergeProps({
        portal: "",
        label: _ctx.$t('agentsTable.actionsMenu.agentDescription.title')
      }, bind, { "data-testid": "agent-description-item" }), {
        default: _withCtx(() => [
          _createVNode(AgentActionSetDescription, {
            "agents-list": [__props.agent],
            onSubmit: _cache[2] || (_cache[2] = (value) => _unref(agentsActions).setAgentDescription([__props.agent], value))
          }, null, 8, ["agents-list"])
        ]),
        _: 2
      }, 1040, ["label"]),
      (_unref(isDefaultMenu))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 2,
            "data-testid": "unsubscribe-agent-action",
            disabled: !_unref(isAgentSubscribed),
            onClick: _cache[3] || (_cache[3] = () => _unref(agentsActions).setRemoveAgentLicense([__props.agent], _unref(License_RegisterAgentAction).UnsubscribeAgent))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(isCloudAgent))
        ? (_openBlock(), _createBlock(AgentCloudBulkActionMenu, _mergeProps({
            key: 3,
            ref: "cloud-menu",
            "hover-mode": "",
            agents: [__props.agent]
          }, _unref(menuOptions).attrs, _toHandlers(_unref(menuOptions).listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true),
      (_unref(isAgentOffline))
        ? (_openBlock(), _createBlock(_component_IcmMenuItem, {
            key: 4,
            "data-testid": "remove-agent",
            onClick: _cache[4] || (_cache[4] = () => _unref(agentsActions).removeAgentLinux([__props.agent]))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16)), [
    [_directive_incredi_focus_trap, 'agent-action-menu']
  ])
}
}

})